import { Card } from '../../components';

export type DeviceCodeInputPageProps = {
  xsrf: string;
  action: string;
  prefill?: string;
  error?: string;
  errorDescription?: string;
};

export function DeviceCodeInputPage({
  xsrf,
  action,
  prefill,
  error,
  errorDescription,
}: DeviceCodeInputPageProps): JSX.Element {
  return (
    <Card header={<h2 className="text-2xl font-medium leading-6 text-gray-900">Device Authorization</h2>}>
      <div className="flex flex-col gap-4 p-2">
        <p className="text-sm text-gray-600">Enter the code shown on your device.</p>
        {error && (
          <div className="rounded-md bg-red-50 border border-red-200 p-3">
            <p className="text-sm text-red-700">{errorDescription ?? error}</p>
          </div>
        )}
        <form method="post" action={action}>
          <input type="hidden" name="xsrf" value={xsrf} />
          <div className="mt-2">
            <label htmlFor="user_code" className="block text-sm font-medium text-gray-700">
              Device Code
            </label>
            <input
              id="user_code"
              name="user_code"
              type="text"
              defaultValue={prefill}
              autoComplete="off"
              autoFocus
              placeholder="XXXX-XXXX"
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-5minds-blue-800 focus:outline-none focus:ring-1 focus:ring-5minds-blue-800 uppercase tracking-widest"
            />
          </div>
          <div className="mt-4 flex justify-end">
            <input
              type="submit"
              value="Continue"
              className="inline-flex items-center rounded-md border border-transparent bg-5minds-blue-800 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-5minds-blue-900 focus:outline-none focus:ring-2 focus:ring-5minds-blue-900 focus:ring-offset-2 cursor-pointer"
            />
          </div>
        </form>
      </div>
    </Card>
  );
}
